import React, { useState } from "react";
import {
  Card,
  IconButton,
  Typography,
  Collapse,
  Divider,
} from "@material-ui/core";
import styles from "./BillingPart.module.scss";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { IBillingPart } from "nodeDetails/types";
import { useDomainNumberFormatter } from "common/useNumberFormatter";
import BillingItem from "./BillingItem";
import BillingPartSummary from "./BillingPartSummary";

interface ExtandProps {
  onClick: () => void;
  expanded: boolean;
}

const Expand = ({ onClick, expanded }: ExtandProps) => {
  const style = {
    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
  };

  return (
    <IconButton style={style} onClick={onClick}>
      <ExpandMore />
    </IconButton>
  );
};

interface HeaderProps {
  expanded: boolean;
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  part: IBillingPart;
}

const Header = ({ part, expanded, setExpanded }: HeaderProps) => {
  const { formatCurrency } = useDomainNumberFormatter();

  const totalSum =
    part.Items.reduce((acc, current) => {
      const total = current.Total || 0;
      const totalVat = current.TotalVat || 0;

      return acc + total + totalVat;
    }, 0) + (part.Rounding || 0);

  return (
    <div className={styles.header}>
      <Typography className={styles.headerTitle} variant="h3">
        {part.Name}
      </Typography>
      <Typography variant="body2">{formatCurrency(totalSum)}</Typography>
      <Expand
        expanded={expanded}
        onClick={() => setExpanded((prev) => !prev)}
      />
    </div>
  );
};

interface Props {
  part: IBillingPart;
}

const BillingPart = ({ part }: Props) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Card className={styles.part}>
      <Header part={part} expanded={expanded} setExpanded={setExpanded} />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Divider className={styles.headerDivider} />
        <div className={styles.content}>
          {part.Items.map((item, i) => (
            <BillingItem
              key={i}
              item={item}
              lastItem={part.Items.length - 1 === i}
            />
          ))}
          <Divider className={styles.summaryDivider} />
          <BillingPartSummary part={part} />
        </div>
      </Collapse>
    </Card>
  );
};

export default BillingPart;
